<template>
    <div class="widget-form-panel-mobile">
        <div class="container-form">
            <div class="container-form-button">
                <button type="button" class="btn btn-xs btn-checkout" :disabled="btnAddItemEnable" @click="add_to_cart">Add Items to Cart</button> 
                <button class="btn btn-xs btn-primary" :disabled="btnValidateEnable" @click="validate_parts">Validate Parts</button>
                <button type="button" class="btn btn-xs btn-primary" :disabled="btnRemoveEnable" @click="remove_invalid">Remove Invalid Parts</button>
                <a type="button" href="templates/Qwik-Order-Import-Template.csv" class="btn btn-xs btn-grey">Download CSV Template</a>
                <button type="button" class="btn btn-xs btn-grey" @click="openUploadCSV = true">CSV Upload</button>
                
            </div>
        </div>		
        <div class="block-space--layout--divider-order-entry"></div>
        <div><strong>Instructions:</strong>&nbsp;The ITEM NUMBER must be a part number, and not a name or description. The MFG CODE is optional, and is 3 characters in length (ex. ACDelco=ACD).  Once you either click "Validate Parts" or you use the CSV Upload, you will need to click "Remove Invalid Parts" if your list contains items that cannot be validated.  You can then click "Add Items to Cart", and be able to further refine your order.</div>
    </div>

    <base-dialog title="Upload CSV" @close="openUploadCSV = false" :open="openUploadCSV">
        <template #default>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label for="checkout-email">CSV</label>
                    <input type="file" class="form-control" id="file-csv" placeholder="CSV File">
                </div>
            </div>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-secondary mr-2" @click="openUploadCSV = false">
            Cancel
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="uploadCSV">
            Yes
        </button>
        </template>
    </base-dialog>
</template>

<script>
// import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            openUploadCSV: false,
            btnAddItemEnable: 'disabled',
            btnValidateEnable: 'disabled',
            btnRemoveEnable: 'disabled',
        };
    },
    props: {
        hasValidated: {
            type: Boolean
        },
        allValid: {
            type: Boolean
        },
        needValidateParts: {
            type: Boolean
        }
    },
    watch: {
        hasValidated(newVal){
            if (newVal == true){
                this.btnRemoveEnable = false;
            }else{
                this.btnRemoveEnable = 'disabled';
            }
        },

        allValid(newVal){
            if (newVal == true){
                this.btnAddItemEnable = false;
            }else{
                this.btnAddItemEnable = 'disabled';
            }
        },

        needValidateParts(newVal){
            if (newVal == true){
                this.btnValidateEnable = false;
            }else{
                this.btnValidateEnable = 'disabled';
            }
        },
    },
    methods: {
        /**
         * send csv to 
         */
        uploadCSV() {
            this.openUploadCSV = false;

            // const formData = new FormData;
            const csvfile = document.getElementById('file-csv').files[0];
            const reader = new FileReader();
            const dis = this;
            let csvData = [];
            reader.addEventListener('load', (e) => {
                const data = e.target.result;
                
                let lbreak = data.split("\n");
                lbreak.forEach((res, i) => {
                    if (i != 0){
                        csvData.push(res.split(","));    
                    }          
                });

                dis.$emit('csvUploaded', csvData);
                dis.btnValidateEnable = false;
            });
            reader.readAsText(csvfile);
        },

        validate_parts() {
            this.$emit('validate_parts');
        },
        remove_invalid() {
            this.$emit('remove_invalid');
        },

        add_to_cart() {
            this.$emit('add_to_cart');
        }
    },

    updated(){
        
    }
}
</script>